import $ from "jquery";
import {isPresent} from "../general";
const _ = require("underscore");
import render from "../render";
const modalHtml = require('../../sharedHtml/modal.html');
const modalBodyHtml = require('./html/commonExportModal.html');
const modalFooterHtml = require('./html/commonExportModalFooter.html');


export function alterSearchCriteriForController(searchCriteria){
	// This omit is require cause, lookup component is adding below information in searchCriteria which was not the case earlier,
	// so instead change controller side code beeter to send what contrller is expecting.
	let revisedSearchCriteria =   _.omit(searchCriteria, function(value, key, object) {
		return (value.key == 'fixedRange' ||  value.key == 'startDate' ||value.key == 'endDate' ); 
	});
	return  _.toArray(revisedSearchCriteria);
}

export function readSpecificKeyFromSearchCriteria(searchCriteria,key){
	let value = "";
	$.each(searchCriteria, function(i, item) {
		if(item.key == key)
		{
			value =  item.value[0];	
		}
	});
	return value;
}


export function pushFilterSessionCacheState() {
	if (history.pushState) {
		let filterTime = new Date().getTime();
		history.pushState(null, null, '?filterApply=' + filterTime);
	}
}

export function retriveCriteriaObjectByKey(searchCriteria,key){
	let targetObj = "";
	$.each(searchCriteria, function(i, item) {
		if(item.key == key)
		{
			targetObj =  item; 
		}
	});
	return targetObj;
}


export function retriveCriteriaObjectByOperation(searchCriteria,operationName){
	let targetObj = "";
	$.each(searchCriteria, function(i, item) {
		if(item.operation == operationName)
		{
			targetObj = item;
		}
	});
	return targetObj;
}


export function doAjax({url, success, error,data}){
	$.ajax({
		  data: data,
		  url: url,
		  type: 'POST',
		  dataType: "json",
		  success: success,
		  error: error,
		  async: false,
	});
}


export function isNew(data){
	let isNewView = false;
	if(data.savedViewTarget == "newSavedView"){
		isNewView = true;
	}
	return isNewView
}


export function readSpecificObjectFromCurrentData(data,keyToRead){
	return data.keyToRead;
}


export function isEdit(data){
	return (data.updateView && data.savedViewTarget != "newSavedView");
}



export function isOnlyLookupDataUpdate(data){
	return (!data.updateView && !isPresent(data.deletedView));
}


export function isDeleteView(data){
	return isPresent(data.deletedView);
}



   
export function prepareDataToSendController(currentData,portletNamespace){
	let startDate = readSpecificKeyFromSearchCriteria(currentData["searchCriteria"],'startDate');
	let endDate = readSpecificKeyFromSearchCriteria(currentData["searchCriteria"],'endDate');	
	let fixedRangeDate = readSpecificKeyFromSearchCriteria(currentData["searchCriteria"],'fixedRange');	
	let revisedSearchCriteria =  alterSearchCriteriForController(currentData["searchCriteria"]);
	portletNamespace = isPresent(portletNamespace) ? portletNamespace : "";
	let data = {  	
			[`${portletNamespace}savedViewTarget`] : currentData.savedViewTarget,
			[`${portletNamespace}savedViewName`] : currentData.savedViewTitle,
			[`${portletNamespace}columns`] : JSON.stringify(currentData.targetColumns),
			[`${portletNamespace}page`] :  currentData["number"],
			[`${portletNamespace}size`] :  currentData["size"],
			[`${portletNamespace}orderByType`] :  currentData["orderByType"],
			[`${portletNamespace}orderBy`] :  currentData["orderBy"] == 'ordStatus' ? "ordStatusCode" : currentData["orderBy"],
			[`${portletNamespace}sortType`] :  currentData["sortType"],
			[`${portletNamespace}sortField`] : currentData["sortField"],
			[`${portletNamespace}searchCriteria`] :  JSON.stringify(revisedSearchCriteria),
			[`${portletNamespace}fixedRange`] :  fixedRangeDate,
			[`${portletNamespace}startDate`] : startDate,
			[`${portletNamespace}endDate`] : endDate,
			[`${portletNamespace}deleteViewTarget`] :  isDeleteView(currentData) ? currentData.deletedView.target : ""
		}
	//Exposing this variable so that we can check/debug at anytime in any environment 	
	window.prepareDataObj = data;	
	return data;		 	
}


//Below is resuable pills class , we can only use if your status from DB you want to display as it is , if there are any business logic around of it like if status is "Pending" you want to display "All pending" in this case , this fun.
// wont help.
let statusPillRenderTemplate = require("./html/statusPillsTemplate.html");

// Just keep adding your status and class here and use statusPillRender method in columns render method.
export let pillStatusClasses = {
  "default" : "q-pill-white-and-grey",
  "Error": "q-pill-red",
  "In Process": "q-pill-blue-border",
  "Released": "q-pill-blue-border",
  "Shipped": "q-pill-blue",
  "Partially Shipped": "q-pill-blue-border",
  "Canceled": "q-pill-light-grey",
  "Held": "q-pill-blue-border",
  "Cancel Pending": "q-pill-light-grey",
  "Hold Pending": "q-pill-blue-border",
  "Pending": " q-pill-blue-border",
  "Backordered": "q-pill-red",
  "Partially Released": "q-pill-blue-border",
  "Self Fulfill": "q-pill-blue",
  "Complete" : "q-pill-green",
  "Delivered" : "q-pill-green",
  "Planned" : "q-pill-blue-border",
  "In Transit" : "q-pill-blue-border",
  "Receiving" : "q-pill-green-border" ,
  "Out of Stock": "q-pill-red",
  "Low Stock": "q-pill-orange",
  "Active" : "q-pill-blue",
  "Inactive" : "q-pill-light-grey",
  "Created" : "q-pill-blue-border"
}



export function statusPillRender(data, type, row) {
    let newRender;
    let pillClass = pillStatusClasses[data] || pillStatusClasses.default ;
    return newRender = render(
      statusPillRenderTemplate, {
        data,
        pillClass
      }
    );
  }


export function removeSpecificObjectFromSearchCriteria(searchCriteria,key) {
	let targetObj = "";
	$.each(searchCriteria, function(i, item) {
		if(item.key == key)
		{
			targetObj=_.without(searchCriteria,item);
		}	
	});
	return targetObj;
  }

export function buildExport() {
	const self = this;
	let url = "";
	let exportModal;

	self.init = function(exportObj) {
		let {title,cssClassNameForCount,exportAttemptTextPart1Lang,exportAttemptTextPart2Lang,exportMaxLimitLang,cssClassNameForExportButtonOnPage,cssClassNameForExportButtonOnPopup,cssClassNameForSelectFileTypeOnPopup} = exportObj;
		let insertTarget = 'body';
		let buildExportModalBody = function() {
		  let exportModalBody = render(
		      modalBodyHtml, {
		          exportAttemptTextPart1Lang :  exportAttemptTextPart1Lang,
		          exportAttemptTextPart2Lang :  exportAttemptTextPart2Lang,
		          exportMaxLimitLang :  exportMaxLimitLang,
		          totalRows: 0,
		          cssClassNameForSelectFileTypeOnPopup:cssClassNameForSelectFileTypeOnPopup,
		          cssClassNameForCount:cssClassNameForCount 
			    }
		  );
		  return exportModalBody;
		}

		

	 
		let buildExportModalFooter = function() {
		  let exportModalFooter = render(
		      modalFooterHtml, {
		      		cssClassNameForExportButtonOnPopup :cssClassNameForExportButtonOnPopup
			    }
		  );
		  return exportModalFooter;
		}

		exportModal = $(render(
	      modalHtml, {
	        title: title,
	        leftAlignTitle: true,
	        topCloseBtn: true,
	        autoHideTop: true,
	        staticBackdrop: false,
	        body: buildExportModalBody(),
	        footerBtns: buildExportModalFooter()
		    }
	    ));


	    $(insertTarget).append(exportModal);

		//exportBtn -  is the css class which present "Export" button on your page.
	    let exportBtn = isPresent(cssClassNameForExportButtonOnPage) ? `.${cssClassNameForExportButtonOnPage}` : ".exportData";
	    //selectFileTypeCls -  is the class of the select drop down where you select file type PDF and CSV.
	    let selectFileTypeCls = isPresent(cssClassNameForSelectFileTypeOnPopup) ? `.${cssClassNameForSelectFileTypeOnPopup}` : ".dataFileType";
	    // modalExportBtnCls- is the css class which present "Export" button on export popup.
		let modalExportBtnCls = isPresent(cssClassNameForExportButtonOnPopup) ? `.${cssClassNameForExportButtonOnPopup}` : ".modalExportData";

	    $(document).on('click',exportBtn, function(){
  				exportModal.modal('show');
	   });	



	 //    $(exportBtn).click(function() {
		//     exportModal.modal('show');
		// });

		

		$(document).on('change', selectFileTypeCls, function(){		
			$(modalExportBtnCls).attr('disabled', false);
		});
	}

	self.buildExportBasicURL = function(resourceURL,currentData,portletNamespace) {
		let startDate = readSpecificKeyFromSearchCriteria(currentData["searchCriteria"],'startDate');
		let endDate = readSpecificKeyFromSearchCriteria(currentData["searchCriteria"],'endDate'); 
		let fixedRangeDate = readSpecificKeyFromSearchCriteria(currentData["searchCriteria"],'fixedRange'); 
		let revisedSearchCriteria =  alterSearchCriteriForController(currentData["searchCriteria"])
		let orderBy =  currentData["orderBy"] == 'ordStatus' ? "ordStatusCode" : currentData["orderBy"]
		let searchCriteria =   _.toArray(revisedSearchCriteria).length > 0 ? JSON.stringify(_.toArray(revisedSearchCriteria)) : _.toArray(revisedSearchCriteria);

		//Ampersand in search criteria data was causing URL parsing issues on server side
		searchCriteria = encodeURIComponent(searchCriteria);

		portletNamespace = isPresent(portletNamespace) ? portletNamespace : "";
		//url = resourceURL+"&endDate="+endDate+"&startDate="+startDate+"&fixedRange="+fixedRangeDate+"&page=0"+"&size=1000"+"&orderBy="+orderBy+"&orderByType="+currentData["sortType"]+"&searchCriteria="+searchCriteria;
		url=resourceURL+[`&${portletNamespace}endDate=`]+endDate+[`&${portletNamespace}startDate=`]+startDate+[`&${portletNamespace}fixedRange=`]+fixedRangeDate+[`&${portletNamespace}page=0&${portletNamespace}size=1000&${portletNamespace}orderBy`]+orderBy+[`&${portletNamespace}orderByType=`]+currentData["sortType"]+[`&${portletNamespace}searchCriteria=`]+searchCriteria;
	}
	 //changes for 7674 
	 self.buildExportCustomBasicURL = function(resourceURL,currentData,portletNamespace) {
		           url=resourceURL;
		        } 

	self.getCurrentUrl = function() {
		return url;
	}

	self.bindExportEvent = function(portletNamespace,cssClassNameForExportButtonOnPopup,cssClassNameForSelectFileTypeOnPopup) {
		//optionalClass = isPresent(optionalClass) ? optionalClass : '.modalExportData';
		//dataFileType = isPresent(dataFileType) ? `${dataFileType} :selected` : '.dataFileType :selected';
 		let selectFileTypeCls = isPresent(cssClassNameForSelectFileTypeOnPopup) ? `.${cssClassNameForSelectFileTypeOnPopup} :selected` : ".dataFileType :selected";
	 	let modalExportBtnCls = isPresent(cssClassNameForExportButtonOnPopup) ? `.${cssClassNameForExportButtonOnPopup}` : ".modalExportData";
		$(document).on('click',modalExportBtnCls, function(){
		    let fileType = $(selectFileTypeCls).val();
		   	portletNamespace = isPresent(portletNamespace) ? portletNamespace : "";
		    let finalURL = url +[`&${portletNamespace}fileType=`]+fileType
		    doExport(finalURL);
		    exportModal.modal("hide");		
		});		
	}

	self.setExportCount = function(exportCount,cssClassNameForCount) {
		let rowCountCss = isPresent(cssClassNameForCount) ? `.${cssClassNameForCount}` : ".row-count";
		$(rowCountCss).html(exportCount);
	}

	function doExport(url) {
		window.open(url);
	}	
}







// WEBPACK FOOTER //
// ./src/utilities/filtersutil/index.js